module.exports = __webpack_public_path__ + "img/up.a0f1e494.svg";